import { render, staticRenderFns } from "./ProductOfShop.vue?vue&type=template&id=4dc5ef5a&scoped=true&"
import script from "./ProductOfShop.vue?vue&type=script&lang=js&"
export * from "./ProductOfShop.vue?vue&type=script&lang=js&"
import style0 from "./ProductOfShop.vue?vue&type=style&index=0&id=4dc5ef5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc5ef5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Administrator\\Desktop\\gtzn\\FreeGoShop\\client_web_food_market\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4dc5ef5a', component.options)
    } else {
      api.reload('4dc5ef5a', component.options)
    }
    module.hot.accept("./ProductOfShop.vue?vue&type=template&id=4dc5ef5a&scoped=true&", function () {
      api.rerender('4dc5ef5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shop/ProductOfShop.vue"
export default component.exports